import React, { useState } from "react";
import { toast } from "react-toastify";
import { useParams } from "react-router-dom";
import { useUpdateCamapignDynamicFieldsMutation, useUpdateCamapignMutation } from "../../../Services/campign/CampaignDetail";
import ReactModal from "react-modal";
import AddingLeadIntoContact from "./AddingLeadIntoContact";
import { CIRCLEONE_USER } from "../../../constants";
interface IProps {
  data: any;
  closeStatusModal: any;
  refetch: any;
  refetchAuditTrail: any;
  selectedStatus: any;
  handleStatusUpdate: any; // Add this prop to handle status update
  refetchAuditTrailData: any;
  selectedAllStatus: any;
  storingTicketId: any;
  creatingNewContactDetails: any;
  campign: any;
}

const ChangeStatusCampaignModal = ({
  data,
  closeStatusModal,
  refetch,
  refetchAuditTrail,
  selectedStatus,
  handleStatusUpdate,
  refetchAuditTrailData,
  selectedAllStatus,
  storingTicketId,
  creatingNewContactDetails,
  campign,
}: IProps) => {
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [openConfirmationModal, setOpenConfirmationModal] = useState(false);
  const [rejectionReason, setRejectionReason] = useState<any>("");
  const [showRejectionConfirmation, setShowRejectionConfirmation] = useState<boolean>(false);
  const params = useParams();
  const uuid = campign.id;
  const [updateDynamicFields] = useUpdateCamapignDynamicFieldsMutation();


  const [updateStatus] = useUpdateCamapignMutation();

  const checkForTenant = localStorage.getItem(CIRCLEONE_USER);

  // For non-rejected and for the second step of rejected
  const handleSubmit = async () => {
    setIsLoading(true);
    try {
      const response = await updateStatus({
        id: storingTicketId ? storingTicketId : `${uuid}`,
        new_status_type: selectedStatus,
        assigned_by: localStorage.getItem("circleone-username"),
        assignee: localStorage.getItem("User_Id"),
        status:
          selectedAllStatus.status_type === "wip" ? selectedAllStatus.id : null, // WIP
        closed_status:
          selectedAllStatus.status_type === "closed"
            ? selectedAllStatus.id
            : null,
        dynamic_fields: {},
        static_fields: {},
      });

      if (response.data) {
        setIsLoading(false);
        toast.success("Status updated successfully!");

        if (
          (selectedAllStatus?.status === "Won" &&
            checkForTenant === "autodealer") ||
          (selectedAllStatus?.status === "Won" && checkForTenant === "meta") ||
          (selectedAllStatus?.status === "Sales order" && checkForTenant === "stage") ||
          (selectedAllStatus?.status === "Sales order" && checkForTenant === "meta") ||
          (selectedAllStatus?.status === "Sales order" && checkForTenant === "vecv")
        ) {

          setOpenConfirmationModal(true);
        } else {
          console.log("else");
          handleStatusUpdate();
          closeStatusModal();
          refetch();
          refetchAuditTrailData();
        }
      } else if (response.error) {
        // Extract error details from the response
        const { status, data }: any = response.error;

        if (data?.detail) {
          // Show detailed error messages dynamically
          data.detail.forEach((message) => {
            toast.error(` ${message}`); // Display each error message
          });
        } else {
          toast.error(
            `Error ${status}: Something went wrong. Please try again.`
          );
        }

        setIsLoading(false); // Reset loading state
      }
    } catch (error) {
      setIsLoading(false); // Reset loading state

    }
  };

  // For rejected, first step: show reason, then show confirmation
  const handleRejectionReasonSubmit = async () => {
    if (!rejectionReason.trim()) {
      toast.error("Please provide a reason for rejection.");
      return;
    } else {

      const editedFields: any =
      {
        "Reason for rejection": rejectionReason
      }

      const updatedTicket = {
        dynamic_fields: editedFields || {},
        assigned_by: localStorage.getItem('circleone-username'),
        assignee: localStorage.getItem('User_Id'),
        status_type: campign?.status_type

      };


      try {
        const response = await updateDynamicFields({
          variables: updatedTicket,
          uuid,
        });

        if (response.data) {
          // Successful API call
          setShowRejectionConfirmation(true);


        } else if (response.error) {
          // Handle error response
          const { status, data }: any = response.error;
          if (data?.email) {
            toast.error(data.email[0]); // Display email error message

          } else if (data?.detail) {
            data.detail.forEach((message) => {
              console.log(message, "messaggegg")
              toast.error(` ${message}`); // Display each error message
            });
          } else {
            toast.error(
              `Error ${status}: Something went wrong. Please try again.`
            );
          }
          setIsLoading(false);
        }
      } catch (error) {
        setIsLoading(false); // Reset loading state
        toast.error("Failed to assign. Please try again."); // Show error toast
        console.error(error); // Log the error
      }
      setShowRejectionConfirmation(true);
    }
  };


  console.log(selectedStatus, "selectedAllStatus")
  const customModalStyles = {
    content: {
      top: "50%",
      left: "50%",
      right: "auto",
      bottom: "auto",
      marginRight: "-50%",
      transform: "translate(-50%, -50%)",
      width: "500px",
      height: "170px",
    },
  };

  return (
    <div className="card-body">
      {selectedAllStatus?.status === "Rejected" ? (
        showRejectionConfirmation ? (
          <>
            <span className="fs-5 fw-bold">
              Are you sure you want to change the status?
            </span>
            <div className="d-flex justify-content-end mt-10">
              <button
                type="reset"
                className="btn btn-sm btn-white me-3"
                onClick={() => setShowRejectionConfirmation(false)}
                disabled={isLoading}
              >
                Cancel
              </button>
              <button
                type="submit"
                className="btn btn-sm btn-primary"
                onClick={handleSubmit}
                disabled={isLoading}
              >
                {isLoading ? "Updating..." : "Update"}
              </button>
            </div>
          </>
        ) : (
          <>
            <span className="fs-5 fw-bold">Reason for rejection</span>
            <textarea
              className="form-control mt-2"
              rows={3}
              value={rejectionReason}
              onChange={e => setRejectionReason(e.target.value)}
              placeholder="Enter reason for rejection"
              disabled={isLoading}
            />
            <div className="d-flex justify-content-end mt-10">
              <button
                type="reset"
                className="btn btn-sm btn-white me-3"
                onClick={closeStatusModal}
                disabled={isLoading}
              >
                Cancel
              </button>
              <button
                type="button"
                className="btn btn-sm btn-primary"
                onClick={handleRejectionReasonSubmit}
                disabled={isLoading}
              >
                Submit
              </button>
            </div>
          </>
        )
      ) : (
        <>
          <span className="fs-5 fw-bold">
            Are you sure you want to change the status?
          </span>
          <div className="d-flex justify-content-end mt-10">
            <button
              type="reset"
              className="btn btn-sm btn-white me-3"
              onClick={closeStatusModal}
              disabled={isLoading}
            >
              Cancel
            </button>
            <button
              type="submit"
              className="btn btn-sm btn-primary"
              onClick={handleSubmit}
              disabled={isLoading}
            >
              {isLoading ? "Updating..." : "Update"}
            </button>
          </div>
        </>
      )}

      <ReactModal
        isOpen={openConfirmationModal}
        onRequestClose={closeStatusModal}
        style={customModalStyles}
        contentLabel="Change Status"
        shouldCloseOnOverlayClick={false}
      >
        <AddingLeadIntoContact
          closeStatusModal={closeStatusModal}
          creatingNewContactDetails={creatingNewContactDetails}
          closeStatusModall={closeStatusModal}
          handleStatusUpdate={handleStatusUpdate}
          refetch={refetch}
        />
      </ReactModal>
    </div>
  );
};

export default ChangeStatusCampaignModal;
